module.exports = __webpack_public_path__ + "img/230.e422aeca.png";